/* eslint-disable no-console */

import {register} from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
    register(`${process.env.BASE_URL}service-worker.js`, {
        ready() {
            if (origin.includes("localhost")) {
                console.log(
                    'App is being served from cache by a service worker.\n' +
                    'For more details, visit https://goo.gl/AFskqB'
                )
            }
        },
        registered() {
            if (origin.includes("localhost")) {
                console.log('Service worker has been registered.')
            }
        },
        cached() {
            if (origin.includes("localhost")) {
                console.log('Content has been cached for offline use.')
            }
        },
        updatefound() {
            if (origin.includes("localhost")) {
                console.log('New content is downloading.')
            }
        },
        updated() {
            if (origin.includes("localhost")) {
                console.log('New content is available; please refresh.')
            }
        },
        offline() {
            if (origin.includes("localhost")) {
                console.log('No internet connection found. App is running in offline mode.')
            }
        },
        error(error) {
            if (origin.includes("localhost")) {
                console.error('Error during service worker registration:', error)
            }
        }
    })
}
